import _ from "lodash";

const API_BASE_URL = process.env.API_BASE_URL;

let _currentUser;

class ApiError extends Error {
  constructor(message, code) {
    super(message);
    this.name = this.constructor.name;
    this.code = code;
    Error.captureStackTrace(this, this.constructor);
  }
}

export const sendRequest = async (
  path,
  method = "GET",
  body = null,
  headers = {},
) => {
  try {
    const url = new URL(`${API_BASE_URL}${path}.json`);

    let defaultHeaders = {
      Accept: "application/json",
      "Content-Type": "application/json; charset=utf-8",
    };

    const opts = {
      method: method,
      headers: {
        ...defaultHeaders,
        ...headers,
      },
      credentials: "include", // cookies
    };

    if (body) {
      if (method === "GET") {
        url.search = new URLSearchParams(body).toString();
      } else if (body && body instanceof FormData) {
        opts.body = body;
      } else {
        opts.headers["Content-Type"] = "application/json";
        opts.body = JSON.stringify(body);
      }
    }

    const response = await fetch(url, opts);
    if (response.status === 204) {
      return {};
    }

    if (!response.ok) {
      if (response.status > 500 && response.status < 600) {
        return { error: "Our servers are having a little nap 😴 Don't worry though, our devs are already chugging coffee and typing furiously to fix it! (status: " + response.status + ")" };
      }

      const json = await response.json();

      if (response.status === 401 && window.location.pathname !== "/login" && !window.location.pathname.startsWith("/T-")) {
        window.location.href = "/login";
        return; // Prevent further execution
      }

      const errors = _.join(_.get(json, "errors.full_messages"), ", ");
      const message = json.message || json.error || errors;
      return { error: message, code: response.status };
    }

    return await response.json();
  } catch (error) {
    // If it's already an ApiError, rethrow it
    if (error instanceof ApiError) {
      throw error;
    }
    
    // If it's a network error or other unexpected error, wrap it in ApiError
    if (error.message === 'Failed to fetch') {
      throw new ApiError('Network error: Please check your internet connection', 'NETWORK_ERROR');
    }
    
    // For any other unexpected errors
    throw new ApiError(error.message || 'An unexpected error occurred', 'UNKNOWN_ERROR');
  }
};

export const currentUser = async () => {
  const user = await sendRequest("/users");
  return _.get(user, "[0]");
};

export const clearCurrentUser = () => {
  _currentUser = null;
};
